import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Cache-bust: unregister any stale service worker and clear caches from prior builds.
// React 19 stale bundles previously caused "destroy is not a function" crashes.
const APP_BUILD_VERSION = "2026-02-pw-v2";
(async () => {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    const stored = localStorage.getItem("pw_build_version");
    if (stored !== APP_BUILD_VERSION) {
      localStorage.setItem("pw_build_version", APP_BUILD_VERSION);
      if (stored) window.location.reload();
    }
  } catch (e) {
    // no-op — never block rendering on cache cleanup
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
